import Ornament from "@/components/Ornament";

const REVIEWS = [
  {
    text: '"The Savji and Butter Chicken Tandoor deliver authentic feast flavours right here in Nagpur."',
    by: "Occasion Diner Review",
  },
  {
    text: '"Great taste and generous portions for family weekend dinners. The mutton biryani is a standout."',
    by: "Nagpur Local Family",
  },
  {
    text: '"True to their motto: Good Food • Great Taste Always. Consistent quality and hot naan straight from the tandoor."',
    by: "Regular Dine-In Guest",
  },
];

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="py-16 px-6 max-w-7xl mx-auto border-t border-[#1E313D]"
    >
      <div className="text-center max-w-2xl mx-auto mb-10" data-reveal>
        <span className="text-xs uppercase tracking-widest text-[#D4AF37] font-semibold">
          Community & Taste
        </span>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#F3EAD8]">
          Guest Experiences in Nagpur
        </h2>
        <Ornament />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {REVIEWS.map((review, i) => (
          <div
            key={i}
            data-testid={`review-card-${i + 1}`}
            data-reveal
            style={{ transitionDelay: `${i * 0.12}s` }}
            className="bg-[#111D25] p-6 rounded-lg border border-[#1E313D]/80 flex flex-col justify-between"
          >
            <p className="text-sm italic text-[#A8B8C0] leading-relaxed">
              {review.text}
            </p>
            <div className="mt-4 pt-3 border-t border-[#1E313D] text-xs text-[#D4AF37]">
              {review.by}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
